import { render, staticRenderFns } from "./TreatmentArea.vue?vue&type=template&id=57490816&"
import script from "./TreatmentArea.vue?vue&type=script&lang=js&"
export * from "./TreatmentArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports